import {BaseConverter} from '../../base/converters/base-converter.converter';
import {ApplicationUserModel} from '../models/application-user.model';
import {ApplicationUser} from '../DTO/applicationUser';
import {AccountingConverter} from './accounting.converter';
import {AggregationConverter} from './aggregation.converter';
import {UnitConverter} from './unit.converter';
import {Injectable} from '@angular/core';
import {AggregationModel} from '../models/aggregation.model';
import {AccountingModel} from '../models/accounting.model';
import {UnitModel} from '../models/unit.model';

@Injectable()
export class ApplicationUserConverter extends BaseConverter<ApplicationUserModel, ApplicationUser> {

  constructor(private aggregationConverter: AggregationConverter, private accountingConverter: AccountingConverter, private unitConverter: UnitConverter) {
    super();
  }

  convertToDto(model: ApplicationUserModel): ApplicationUser {
    if (!model) {
      return;
    }
    return {
      appId: model.appId,
      identityId: model.identityId,
      aggregations: this.aggregationConverter.convertToDtoList(model.aggregations),
      managedAccounting: this.accountingConverter.convertToDto(model.managedAccounting),
      managedCustomersAccounts: model.managedCustomersAccounts,
      managedCustomersSet: model.managedCustomersSet,
      managedUnits: this.unitConverter.convertToDtoList(model.managedUnits),
      roles: model.roles,
      uida: model.uida,
      unit: model.unit,
      external:model.external,
      name: model.name
    };
  }

  convertToModel(dto: ApplicationUser): ApplicationUserModel {
    if (!dto) {
      return;
    }
    let model = new ApplicationUserModel();
    model.appId = dto.appId;
    model.identityId = dto.identityId;
    model.unit = dto.unit;
    model.uida = dto.uida;
    model.roles = dto.roles;
    model.managedUnits = this.unitConverter.convertToModelList(dto.managedUnits);
    model.managedCustomersSet = dto.managedCustomersSet;
    model.managedCustomersAccounts = dto.managedCustomersSet;
    model.managedAccounting = this.accountingConverter.convertToModel(dto.managedAccounting);
    model.aggregations = this.aggregationConverter.convertToModelList(dto.aggregations);
    model.external = dto.external;
    model.name = dto.name;
    return model;
  }

  convertUserFormStorage(userStorage): ApplicationUserModel {
    let user = new ApplicationUserModel();
    user.appId = userStorage._appId;
    user.identityId = userStorage._identityId;
    user.uida = userStorage._uida;
    user.roles = userStorage._roles;
    user.unit = userStorage._unit;
    user.external = userStorage._external;
    user.name = userStorage._name;
    user.aggregations = [];

    if (userStorage._aggregations) {
      for (let agg of userStorage._aggregations) {
        let aggregation: AggregationModel = new AggregationModel();
        aggregation.unit = agg._unit;
        aggregation.roles = agg._roles;
        aggregation.id = agg._id;
        user.aggregations.push(aggregation);
      }
    }
    user.managedAccounting = new AccountingModel(userStorage._managedAccounting?._accountCode, userStorage._managedAccounting?._customerCode);
    user.managedCustomersAccounts = userStorage._managedCustomersAccounts;
    user.managedCustomersSet = userStorage._managedCustomersSet;
    user.managedUnits = [];

    if (userStorage._managedUnits) {
      for (let mu of userStorage._managedUnits) {
        let unit: UnitModel = new UnitModel();
        unit.accountCode = mu._accountCode;
        unit.code = mu._code;
        unit.customerCode = mu._customerCode;
        unit.description = mu._description;
        unit.id = mu._id;
        user.managedUnits.push(unit);
      }
    }
    return user;
  }
}
